module.exports = __webpack_public_path__ + "img/D3.bd84cc5f.png";